import React, {useCallback, useState} from 'react';

import {DataCatalogFileVariableName} from 'analysis-tool/AnalysisStepConfigVariableNames';
import {AnalysisTemplateSelectorTemplate} from 'analysis-tool/graphql/AnalysisTemplateSelectorQuery';
import {analysisTemplatePageUrl} from 'analysis-tool/templates/AnalysisTemplateDAO';
import MultiAnalysisTemplateSelector from 'analysis-tool/templates/MultiAnalysisTemplateSelector';
import BaseEditableField from 'ui-library/BaseEditableField';
import Chip from 'ui-library/chips/Chip';
import {ChipSize} from 'ui-library/chips/Chip';

export function isFileProcessingTemplate(template: AnalysisTemplateSelectorTemplate): boolean {
  return (
    template.dataFrameVariables.length === 0 &&
    template.configVariables.length === 1 &&
    template.configVariables[0].configVariableKey === DataCatalogFileVariableName.FILE_ID
  );
}

interface AnalysisTemplatesEditableFieldProps {
  initialSelection: Array<AnalysisTemplateSelectorTemplate>;
  onComplete: (selectedTemplates: Array<AnalysisTemplateSelectorTemplate>) => void;
  isWritable: boolean;
}

export default function AnalysisTemplatesEditableField(
  props: AnalysisTemplatesEditableFieldProps
): JSX.Element {
  const [selectedTemplates, setSelectedTemplates] = useState<Array<AnalysisTemplateSelectorTemplate>>(
    props.initialSelection
  );
  const [isBeingEdited, setIsBeingEdited] = useState(false);

  const handleTemplateChange = useCallback((templates: Array<AnalysisTemplateSelectorTemplate>) => {
    setSelectedTemplates(templates);
  }, []);

  return (
    <BaseEditableField
      editor={
        <MultiAnalysisTemplateSelector
          filterTemplates={isFileProcessingTemplate}
          selectedItems={selectedTemplates}
          onChange={handleTemplateChange}
          shouldAllowMultiple={true}
          hideSelectedResults={true}
        />
      }
      isBeingEdited={isBeingEdited}
      isCompleteEnabled={true}
      isWritable={props.isWritable}
      viewer={
        <div>
          {selectedTemplates.map((template) => (
            <Chip
              key={template.id}
              className="u-mini-spacing-top u-mini-spacing-right"
              text={template.name}
              size={ChipSize.MINI}
              href={analysisTemplatePageUrl(template.id)}
            />
          ))}
        </div>
      }
      onCancel={function (): void {
        setIsBeingEdited(false);
        setSelectedTemplates(props.initialSelection);
      }}
      onComplete={function (): void {
        setIsBeingEdited(false);
        props.onComplete(selectedTemplates);
      }}
      onEdit={function (): void {
        setIsBeingEdited(true);
      }}
    />
  );
}
